import { HiddenPropsCommon } from './index'

export type InputHiddenProps = {
  initialValue?: string | number | undefined
} & HiddenPropsCommon

export const InputHidden = ({ name, ...props }: InputHiddenProps) => <input type="hidden" name={name} {...props} />
